/* eslint-disable max-len */
import React, {useState, useEffect} from 'react'
import { Link } from 'react-router-dom'
import { distributorService } from '../../../service/distributor.service'

const Footer = () => {
    const [resourceCategoriesList,setResourceCategoriesList] = useState([])
    const categories = JSON.parse(localStorage.getItem('user'))?.profile.PRODUCT_CATEGORIES
    const allCategories = []
    categories?.forEach(element => {
        const item = element.split('.')[0]
        if(!allCategories.includes(item)) allCategories.push(item);
    });
    const handleFetchResourceCategories = async () => {
        const response = await distributorService.GetResourceCategoryList(3)
        if(response.error === false) {
            setResourceCategoriesList(response.data.data.Items)
        }
    }

    useEffect(() => {
        handleFetchResourceCategories()
    }, []);
    return (
        <footer className="sm:px-5 px-3 sm:pt-[64px] pt-[34px] pb-[34px] mt-[13px] flex xl:flex-nowrap flex-wrap bg-[#F5F5FA] w-full rounded-lg">
            <div className="xl:w-[20%] lg:w-[25%] md:w-[30%] sm:w-[50%] w-[100%] flex justify-between sm:mb-5 mb-4 sm:border-r-2 xl:pr-8 sm:border-[#ED1C24] " >
                <ul className="w-1/2">
                    <li> 
                        <a href="#" className="text-sm60 text-black font-semibold">Our Products</a>
                    </li>
                    {allCategories.map((item,itemIndex) => (
                        <li className="sm:pt-[30px] pt-2.5" key={`cat${itemIndex}`}>
                            <Link to={`/products?category=${item}`} className="text-sm text-black font-normal">{item}</Link>
                        </li>
                    )
                    )}
                </ul>
                <ul className="w-1/2">
                    <li>
                        <a href="#" className="text-sm60 text-black font-semibold">Resources</a>
                    </li>
                    {resourceCategoriesList.map((item,itemIndex) => (
                        <li className="sm:pt-[30px] pt-2.5" key={`res${itemIndex}`}>
                            <Link to={`/manage-resource?category=${item.resource_category_id}`} className="text-sm text-black font-normal">{item.name}</Link>
                        </li>
                    )
                    )}
                </ul>
            </div>
            <div className="xl:w-[20%] lg:w-[25%] md:w-[30%] sm:w-[40%] w-[100%] items-start flex xl:justify-center sm:mb-5 mb-4 sm:justify-end justify-start xl:border-r-2  xl:border-[#ED1C24] sm:pr-3">
                <ul>
                    <li>
                        <a href="https://www.adorwelding.com/terms-conditions/" target="_blank" rel="noreferrer" className="text-center sm:leading-[8px] leading-[15px] text-sm60 text-black font-semibold">Terms and Conditions</a> 
                    </li>
                    <li className="sm:pt-10 pt-2">
                        <a href="https://www.adorwelding.com/privacy-policy/" target="_blank"  rel="noreferrer" className="text-center  sm:text-sm60 text-sm text-black font-semibold">Privacy Policy</a>
                    </li>
                    <li className="sm:pt-10 pt-2">
                        <a href="#" className="text-center  sm:text-sm60 text-sm text-black font-semibold">Trade Policy</a> 
                    </li>
                </ul>
            </div>       
            <div className="xl:w-[24%] lg:w-[25%] md:w-[40%] sm:w-[34%] w-[40%] address-side sm:mb-5 mb-4 flex md:px-5 px-0">
                <div className="flex items-start">
                    <img src="images/location-red.svg" alt="img" className="mr-1 pt-1"/>
                    <a href="https://goo.gl/maps/TLsP79n1jALDe9jJ6" target="_blank" rel="noreferrer"><p className="text-sm62 text-black font-normal break-all">  
                        Corporate Marketing Office: <br/>
                        Survey No. 147/2B+3, Akurdi, <br/>
                        Near Khandoba Mandir <br/>
                        Chinchwad, Pune - 411 019,<br/>
                        Maharashtra, India 
                    </p></a>
                </div>
            </div>
            <ul className="xl:w-[24%] lg:w-[25%] md:w-[40%] sm:w-[34%] w-[40%] sm:px-0 px-3 browser-link sm:mb-5 mb-4 xl:border-r-2  xl:border-[#ED1C24]">
                <div className="flex items-center sm:pb-4 pb-3 lg:pr-10 pr-0">
                    <img src="images/red-Browser.svg" alt="img" className="mr-2 cursor-pointer "/>
                    <a href="https://www.adorwelding.com/" target="_blank" rel="noreferrer">    
                        <span className="text-sm61 text-black font-normal">www.adorwelding.com</span> 
                    </a>
                </div>
                <div className="flex items-center sm:pb-4 pb-3 lg:pr-10 pr-0">
                    <img src="images/email-red.svg" alt="img" className="mr-2 cursor-pointer"/>
                    <a href="mailto:care@adorians.com" >     
                        <span className="text-sm61 text-black font-normal">care@adorians.com</span> 
                    </a>
                </div>
                <div className="flex items-center sm:pb-4 pb-3 lg:pr-10 pr-0">
                    <img src="images/phone-red.svg" alt="img" className="mr-2 cursor-pointer"/>
                    <a href="tel:18002331071" target="_blank" rel="noreferrer">     
                        <span className="text-sm61 text-black font-normal">18002331071 (Toll - Free)</span> 
                    </a>
                </div>
                <div className="flex items-center sm:pb-4 pb-3 lg:pr-10 pr-0">
                    <img src="images/watsap-red.svg" alt="img" className="mr-2 cursor-pointer"/>
                    <a href="https://wa.me/+912040706000/" target="_blank" rel="noreferrer">     
                        <span className="text-sm61 text-black font-normal">+91 20 40706000</span>
                    </a>
                </div>
            </ul>
            <div  className="xl:w-[12%] w-[35%] sm:w-[22%] sm:block hidden xl:pl-8 sm:mb-5 mb-4 xl:pr-0 pr-10">
                <p className="xl:text-center  text-sm57 sm:leading-[8px] leading-[20px] font-semibold">Follow Us</p>
                <div className="flex xl:justify-center pt-5">
                    <a href="https://www.facebook.com/AdorWeldingLtd" target="_blank" rel="noreferrer">  
                        <img src="images/facebook-black.svg" alt="img" className="cursor-pointer"/>
                    </a>
                    <a href="https://www.linkedin.com/company/ador-welding-ltd./" target="_blank" rel="noreferrer">  
                        <img src="images/linkdin-black.svg" alt="img" className="ml-5 cursor-pointer"/>
                    </a>
                </div>
                <div className="flex xl:justify-center">
                    <a href="https://www.youtube.com/user/AdorWeldingLimited" target="_blank" rel="noreferrer">
                        <img src="images/youtube-black.svg" alt="img" className="cursor-pointer"/> 
                    </a>
                    <a href="https://twitter.com/AdorWeldingLtd" target="_blank" rel="noreferrer" >  
                        <img src="images/twitter-black.svg" alt="img" className="ml-5 cursor-pointer"/>
                    </a>
                </div>
            </div>
        </footer>
    )
}

export default Footer
